import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import Export from "../JournalEntry/List/Export";
import Filter from "../JournalEntry/List/Filter";
import Button from "../Reusable/Button";
import DataTable from "../Reusable/Datatable";
import TableSearch from "../Reusable/Datatable/components/Search";
import TableActionButton from "../Reusable/TableActionButton";
import NACell from "../Reusable/Datatable/NACell";

const SupplierList = (props: any) => {
  const navigate = useNavigate();
  const onRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };

  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "full_name",
      header: "Supplier Name",
      cell: NACell,
    },
    {
      accessorKey: "email",
      header: "Email",
      cell: NACell,
    },
    {
      accessorKey: "mobile_number",
      header: "Mobile Number",
      cell: NACell,
    },
    {
      accessorKey: "vat_pan",
      header: "PAN/VAT",
      cell: NACell,
    },
    {
      accessorKey: "email",
      header: "Email",
      cell: NACell,
    },
    {
      accessorKey: "is_supplier",
      header: "Type",
      cell: ({ row, getValue }: any) => {
        return <p>{getValue() ? "Supplier" : "Customer"}</p>;
      },
    },
  ];

  return (
    <div className={tw`space-y-4`}>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>Supplier</h1>
        <div className={tw`flex items-center gap-x-6`}>
          <Filter />
          <Export />
        </div>
      </div>
      <div className={tw`flex gap-x-2`}>
        <TableSearch />
        <div className={tw`w-32`}>
          <Button
            label="Add New "
            onClick={() => navigate("create")}
            type="button"
          />
        </div>
      </div>
      <DataTable
        url={APIS.USER}
        columns={columns}
        queryKey={"party-info"}
        params={{ is_supplier: true }}
        customSearch={true}
        tableName="supplier-info"
        onRowClick={onRowClick}
      />
    </div>
  );
};

export default SupplierList;

